/*
 * @Author: LeeHuiXian
 * @version:
 * @Date: 2020-04-28 13:49:39
 * @LastEditors: LeeHuiXian
 * @LastEditTime: 2020-04-28 13:51:33
 * @FilePath: /goldenSalesMobile/src/api/ticket.js
 * @Description:
 */
import { requestOfGet } from "../utils/http"
const baseUrl = 'wechath5/zh-cn/v1/ticket'

// 销售列表（推销员）
export function getSalesOrderList(param) {
  return requestOfGet(baseUrl, param)
}
